<app-card>
  <div class="login-container">
    <div class="login">
      <h1 class="login__title">{{ 'auth.login.title' | transloco }}</h1>
      <p class="login__subtitle">{{ 'auth.login.subtitle' | transloco }}</p>

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login__form">
        <app-alert-card *ngIf="loginError" [message]="loginError" [type]="'error'" [dismissible]="false"></app-alert-card>

        <!-- Google SSO Button -->
        <div class="col-sm btn btn-sm border d-flex align-items-start justify-content-center custom-btn" (click)="googleAuth()">
          <img class="me-2" alt="" src="assets/img/google.svg"/>
          <p class="mb-0">{{ 'auth.login.signInWithGoogle' | transloco }}</p>
        </div>

        <!-- Divider OR -->
        <div>
          <div class="row mt-3 mb-3 align-items-center">
            <div class="col-5 d-flex"><hr class="w-100"></div>
            <div class="col-2 text-center middle-text opacity_text"><h3>{{ 'auth.login.or' | transloco }}</h3></div>
            <div class="col-5"><hr class="w-100"></div>
          </div>
        </div>

        <app-input
          type="email"
          [label]="'auth.login.emailLabel' | transloco"
          id="email"
          formControlName="email"
          [placeholder]="'auth.login.emailPlaceholder' | transloco"
          [required]="true"
          [errorMessage]="getErrorMessage('email')"
          [hasIcon]="true"
          iconPosition="left">
          <i slot="icon-left" class="fas fa-envelope" aria-hidden="true"></i>
        </app-input>

        <app-input
          type="password"
          [label]="'auth.login.passwordLabel' | transloco"
          id="password"
          formControlName="password"
          [placeholder]="'auth.login.passwordPlaceholder' | transloco"
          [required]="true"
          [errorMessage]="getErrorMessage('password')"
          [hasIcon]="true"
          iconPosition="left">
          <i slot="icon-left" class="fas fa-lock" aria-hidden="true"></i>
        </app-input>

        <div class="login__forgot-password">
          <a [routerLink]="languageRoutingService.getLocalizedRoute('/forgot-password')">{{ 'auth.login.forgotPassword' | transloco }}</a>
        </div>

        <app-button type="submit" size="lg" [block]="true" [disabled]="isSubmitting">
          {{ isSubmitting ? ('auth.login.signingIn' | transloco) : ('auth.login.signIn' | transloco) }}
        </app-button>

        <div class="login__register">
          {{ 'auth.login.noAccount' | transloco }}
          <a [routerLink]="languageRoutingService.getLocalizedRoute('/register')">{{ 'auth.login.signUp' | transloco }}</a>
        </div>
      </form>
    </div>
  </div>
</app-card>
